import { CommonModule } from '@angular/common';
// This Module's Components
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// Angular Imports
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SessionTimeOutComponent } from './session-time-out.component';

@NgModule({ declarations: [SessionTimeOutComponent],
    exports: [SessionTimeOutComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule, ModalModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class SessionTimeOutModule {}
